import React, { useContext, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import FileDetailsPreview from '../../../../../../../components/FileDetailsPreview'
import MultipleOptionsPreview from '../../../MultipleOptionsPreview'
import FieldLabelWrapper from '../../../../../../../features/components/Form/FieldLabelWrapper'

import { getFacebookVideoPicture } from '../../../../../../../features/components/FacebookPreviews/FacebookSingleMediaAdPreview/FacebookSingleMediaAdThumbnail/FacebookVideoPreview/helpers'

import { choicesCTAByGoalSelector } from '../../../../../../../modules/selectors/choices'
import { facebookImageUrlsSelector } from '../../../../../../../modules/selectors/mediaFiles'

import {
  CALL_TO_ACTION,
  CLICK_THROUGH_LINK,
  CUSTOMIZED_STORY_FILE,
  DESCRIPTIONS_LIST,
  HEADLINES_LIST,
  IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY
} from '../../../../fields'
import {
  FILE_NAME,
  FILE_URL,
  IMAGE_HASH,
  MEDIA_TYPE,
  VIDEO_PICTURE
} from '../../../../../../ReusableFormFields/AdFileUpload/fields'

import { AdFacebookEditContext } from '../../../AdFacebookEditContextProvider'

import useStyles from './styles'

const MediaPreview = ({ adValues, values = {} }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { campaignObjective } = useContext(AdFacebookEditContext)
  const ctaOptionsByGoal = useSelector(choicesCTAByGoalSelector(campaignObjective))
  const imageUrls = useSelector(facebookImageUrlsSelector)

  const selectedAction = useMemo(
    () => ctaOptionsByGoal.find(action => action.name === adValues[CALL_TO_ACTION]),
    [ctaOptionsByGoal, adValues]
  )
  const selectedActionLabel = selectedAction?.label

  const headlinesList = adValues[HEADLINES_LIST]
  const descriptionsList = adValues[DESCRIPTIONS_LIST]
  const mediaType = adValues[MEDIA_TYPE]
  const fileUrl = adValues[FILE_URL]
  const videoPicture = getFacebookVideoPicture(
    {
      [IMAGE_HASH]: adValues[IMAGE_HASH],
      [VIDEO_PICTURE]: adValues[VIDEO_PICTURE]
    },
    imageUrls
  )

  const customizedStoryMediaType = values[CUSTOMIZED_STORY_FILE]?.[MEDIA_TYPE]
  const customizedStoryVideoPicture = getFacebookVideoPicture(
    {
      [IMAGE_HASH]: values[CUSTOMIZED_STORY_FILE]?.[IMAGE_HASH],
      [VIDEO_PICTURE]: values[CUSTOMIZED_STORY_FILE]?.[VIDEO_PICTURE]
    },
    imageUrls
  )
  const customizedStoryFileUrl = values[CUSTOMIZED_STORY_FILE]?.[FILE_URL]
  const isCurrentMediaCustomizedWithStory = values[IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY]

  return (
    <>
      {/*file*/}

      {isCurrentMediaCustomizedWithStory ? (
        <>
          <FieldLabelWrapper label={t('Feed media file')}>
            <FileDetailsPreview
              className={classes.filePreview}
              fileName={adValues[FILE_NAME]}
              fileUrl={mediaType === 'video' ? videoPicture : fileUrl}
              filePreviewType={'image'}
              isFileLoading={false}
              allowDelete={false}
            />
          </FieldLabelWrapper>
          <FieldLabelWrapper label={t('Stories and reels file')}>
            <FileDetailsPreview
              className={classes.filePreview}
              fileName={values[CUSTOMIZED_STORY_FILE][FILE_NAME]}
              fileUrl={customizedStoryMediaType === 'video' ? customizedStoryVideoPicture : customizedStoryFileUrl}
              filePreviewType={'image'}
              isFileLoading={false}
              allowDelete={false}
            />
          </FieldLabelWrapper>
        </>
      ) : (
        <FileDetailsPreview
          className={classes.filePreview}
          fileName={adValues[FILE_NAME]}
          fileUrl={mediaType === 'video' ? videoPicture : fileUrl}
          filePreviewType={'image'}
          isFileLoading={false}
          allowDelete={false}
        />
      )}

      {/*headlines*/}
      <div className={classes.text}>
        <MultipleOptionsPreview optionsTitle={'Headline(s):'} optionsList={headlinesList} />
      </div>
      {/*descriptions*/}
      <div className={classes.text}>
        <MultipleOptionsPreview optionsTitle={'Description(s):'} optionsList={descriptionsList} />
      </div>

      {/*link*/}
      <div className={classes.text}>
        <b>{t('Call-to-action: ')}</b> {t(selectedActionLabel)}
      </div>
      <div className={classnames(classes.text, classes.linkPreview)}>
        <b>{t('Click through link: ')}</b> {adValues[CLICK_THROUGH_LINK]}
      </div>
    </>
  )
}

export default MediaPreview
